import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filter: {
    authGroup: {
      items: [],
      quickFilterValues: []
    },
    admissionPerson: {
      items: [],
      quickFilterValues: []
    },
    carryRequest: {
      items: [],
      quickFilterValues: []
    },
    mdfAdmissionRequest: {
      items: [],
      quickFilterValues: []
    },
    admissionHistory: {
      items: [],
      quickFilterValues: []
    },
    contact: {
      items: [],
      quickFilterValues: []
    },
    contactsAdmissionPerson: {
      items: [],
      quickFilterValues: []
    }
  },
  buttonFilter: {
    authGroup: {
      items: []
    },
    admissionPerson: {
      items: []
    },
    carryRequest: {
      items: []
    },
    mdfAdmissionRequest: {
      items: []
    },
    admissionHistory: {
      items: []
    },
    contact: {
      items: []
    },
    contactsAdmissionPerson: {
      items: []
    }
  },
  pagination: {
    authGroup: {},
    admissionPerson: {},
    carryRequest: {},
    mdfAdmissionRequest: {},
    admissionHistory: {},
    contact: {},
    contactsAdmissionPerson: {}
  },
  sort: {
    authGroup: [],
    admissionPerson: [],
    carryRequest: [],
    mdfAdmissionRequest: [],
    admissionHistory: [],
    contact: [],
    contactsAdmissionPerson: []
  },
  columnOrder: {
    authGroup: [],
    admissionPerson: [],
    carryRequest: [],
    carryRequestCheckedInGoods: [],
    carryRequestContacts: [],
    carryRequestVehicles: [],
    mdfAdmissionRequest: [],
    mdfAdmissionRequestLineInfo: [],
    mdfAdmissionRequestContacts: [],
    admissionHistory: [],
    contact: [],
    contactsAdmissionPerson: [],
    authGroupGateGroups: [],
    project: [],
    childAuthGroups: []
  },
  columnWidth: {
    authGroup: [],
    admissionPerson: [],
    carryRequest: [],
    carryRequestCheckedInGoods: [],
    carryRequestContacts: [],
    carryRequestVehicles: [],
    mdfAdmissionRequest: [],
    mdfAdmissionRequestLineInfo: [],
    mdfAdmissionRequestContacts: [],
    admissionHistory: [],
    contact: [],
    contactsAdmissionPerson: [],
    authGroupGateGroups: [],
    project: [],
    childAuthGroups: []
  }
};

const slice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    /**
     * @see https://blog.logrocket.com/redux-immutable-update-patterns/#redux-toolkit
     * ネストされたオブジェクトの場合、state.filter[tableName] = {...action.payload.filterModel}のように書くと下記のエラーになる場合があるため、
     * itemsとquickFilterValuesをそれぞれ更新する必要がる。
     * Cannot add property 0, object is not extensible
     * TypeError: Cannot add property 0, object is not extensible
     * また、state.filter[tableName].items = items;のように書いても同様のエラーが発生する場合があり、...演算子を使ってcopyしたデータを返す必要がある。
     */
    setTableFilterModel(state, action) {
      const { tableName, buttonFilterFieldNames } = action.payload;
      const { items, quickFilterValues } = action.payload.filterModel;
      state.filter[tableName].items = [
        ...items.filter((item) => !buttonFilterFieldNames.includes(item.field))
      ];
      state.filter[tableName].quickFilterValues = [...quickFilterValues];
      state.buttonFilter[tableName].items = [
        ...items.filter((item) => buttonFilterFieldNames.includes(item.field))
      ];
    },
    setTablePaginationModel(state, action) {
      const { tableName, paginationModel } = action.payload;
      state.pagination[tableName] = { ...paginationModel };
    },
    setTableSortModel(state, action) {
      const { tableName, sortModel } = action.payload;
      state.sort[tableName] = [...sortModel];
    },
    setTableColumnOrderModel(state, action) {
      const { tableName, columnOrderModel } = action.payload;
      state.columnOrder[tableName] = [...columnOrderModel];
    },
    setTableColumnWidthModel(state, action) {
      const { tableName, columnWidthModel } = action.payload;
      state.columnWidth[tableName] = [...columnWidthModel];
    }
  }
});

export const reducer = slice.reducer;

export const setTableFilterModel =
  (tableName, filterModel, buttonFilterFieldNames = []) =>
  (dispatch) => {
    const newFilterModel = { tableName, filterModel, buttonFilterFieldNames };
    dispatch(slice.actions.setTableFilterModel(newFilterModel));
  };

export const setTablePaginationModel =
  (tableName, paginationModel) => (dispatch) => {
    const newPaginationModel = { tableName, paginationModel };
    dispatch(slice.actions.setTablePaginationModel(newPaginationModel));
  };

export const setTableSortModel = (tableName, sortModel) => (dispatch) => {
  const newSortModel = { tableName, sortModel };
  dispatch(slice.actions.setTableSortModel(newSortModel));
};

export const setTableColumnOrderModel =
  (tableName, columnOrderModel) => (dispatch) => {
    const newColumnOrderModel = { tableName, columnOrderModel };
    dispatch(slice.actions.setTableColumnOrderModel(newColumnOrderModel));
  };

export const setTableColumnWidthModel =
  (tableName, columnWidthModel) => (dispatch) => {
    const newColumnWidthModel = { tableName, columnWidthModel };
    dispatch(slice.actions.setTableColumnWidthModel(newColumnWidthModel));
  };

export default slice;
